import React from "react";

const imageConsentForm = () => {
  return (
    <div className="mb-3 p-4">
      <p className="mb-2 font-medium">
        For this quality control and certification process, we (the study doctor
        and study staff) here at Retina Specialty Institute are asking your
        permission:
      </p>
      <ul className="list-disc font-medium list-inside mb-2 text-black ">
        <li className="font-medium text-black ">
          To allow any images that have been or will be taken of your eyes to be
          forwarded to external Central Reading Centers (CRC) for the purpose of
          evaluating and certifying our photographers and equipment for clinical
          trials.
        </li>
        <li  className="font-medium text-black ">
          To allow any images that have been or will be taken of your eyes to be
          used for research purposes.
        </li>
      </ul>
      <p className="mb-2 text-black  font-medium">
        The data collected from these images is not to be shared with anyone but
        the CRC and Retina Specialty Institute for certification and research
        purposes only. The images submitted to the CRC and used for research
        will not contain any identifying information such as your name, social
        security number, date of birth, race, or gender.
      </p>
      <p className="mb-2 font-medium">
        I hereby consent to release any images that have been or will be taken
        of my eyes. I understand that these images will only be forwarded to
        external Central Reading Centers for the purpose of evaluating and
        certifying Retina Specialty Institute photographers, equipment for
        clinical trials, and for research purposes.
      </p>
      <p className="mb-2 font-medium">
        I understand that I may revoke this authorization at any time by
        notifying Retina Specialty Institute in writing.
      </p>
    </div>
  );
};

export default imageConsentForm;
